import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/lib/auth";
import { CustomerProvider } from "@/lib/customer";
import { ThemeProvider } from "@/lib/theme";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import MyDay from "@/pages/MyDay";
import PoView from "@/pages/PoView";
import PoHistory from "@/pages/PoHistory";
import Customers from "@/pages/Customers";
import Board from "@/pages/Board";
import Tasks from "@/pages/Tasks";
import NewPo from "@/pages/NewPo";
import AllPos from "@/pages/AllPos";
import Dashboard from "@/pages/Dashboard";
import Reports from "@/pages/Reports";
import SettingsPage from "@/pages/SettingsPage";
import ImportPage from "@/pages/ImportPage";
import "@/App.css";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="flex min-h-screen items-center justify-center text-sm text-muted-foreground">
        Loading…
      </div>
    );
  if (user === false) return <Navigate to="/login" replace />;
  return children;
}

function ManagerOnly({ children }) {
  const { isManager } = useAuth();
  if (!isManager) return <Navigate to="/my-day" replace />;
  return children;
}

function AdminOnly({ children }) {
  const { isAdmin } = useAuth();
  if (!isAdmin) return <Navigate to="/my-day" replace />;
  return children;
}

export default function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <AuthProvider>
          <CustomerProvider>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              element={
                <Protected>
                  <Layout />
                </Protected>
              }
            >
              <Route path="/" element={<Navigate to="/my-day" replace />} />
              <Route path="/my-day" element={<MyDay />} />
              <Route path="/board" element={<Board />} />
              <Route
                path="/customers"
                element={
                  <AdminOnly>
                    <Customers />
                  </AdminOnly>
                }
              />
              <Route path="/po-history" element={<PoHistory />} />
              <Route path="/po-history/:id" element={<PoView />} />
              <Route path="/po-records/:id" element={<PoView />} />
              <Route path="/tasks" element={<Tasks />} />
              <Route path="/po-new" element={<NewPo />} />
              <Route path="/pos" element={<AllPos />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/reports" element={<Reports />} />
              <Route path="/import" element={<ImportPage />} />
              <Route
                path="/settings"
                element={
                  <ManagerOnly>
                    <SettingsPage />
                  </ManagerOnly>
                }
              />
            </Route>
            <Route path="*" element={<Navigate to="/my-day" replace />} />
          </Routes>
          </CustomerProvider>
        </AuthProvider>
      </BrowserRouter>
    </ThemeProvider>
  );
}
